/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Box from '@material-ui/core/Box';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useSelector, useDispatch } from 'react-redux';
import Contact from './Contact';
import Contracts from './Contracts';
import Manufacturers from './Manufacturers';
import { needsAttention, navigate } from './ConstantData';
import {
  dispatchTabValue,
  getContactAnomaliesByCriteria,
  getCopyContactAnomaliesByCriteria,
  getContractInfo,
  getMfgInfo,
  getNeedInfoMsg,
  saveContactMajor,
  dispatchErrorMessageData,
  dispatchInputValue,
  dispatchMultipleSaveData,
  handleSuccessMessages,
  dispatchCopyContactAnomaliesCriteriaList,
  dispatchContactAnomaliesCriteriaList,
  dispatchContractCriteriaList,
  dispatchMfgCriteriaList,
  dispatchNeedInfoMsg,
  dispatchSaveContact,
  saveContactMajorClose,
} from '../store/Actions';
import {
  isNumeric,
  closeTab,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
  ERR_PAGINATE_VALUE,
  SUCCESSMESSAGE_GENERIC,
  CONTACT_ANOMALIES_NO_DATA,
} from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../../Maintain/Manufacturer/store/ManufacturerAction';

const ContactAnomalies = () => {
  const [contactAnoMaliesList, setContactAnoMaliesList] = useState([]);
  const [curIndex, setCurIndex] = useState();
  const [tabValue, setTabValue] = useState();
  const [contactValues, setContactValues] = useState([]);
  const [copyContactValues, setCopyContactValues] = useState([]);
  const [contractValues, setContractValues] = useState([]);
  const [mfgValues, setMfgValues] = useState([]);
  const [needsAttCodeValue, setNeedCodeValues] = useState('');
  const [savePayload, setSavePayload] = useState([]);
  const [pageEdited, setPageEdited] = useState(false);
  const [disableSaveCancel, setDisableSaveCancel] = useState(false);
  const [cancelView, setCancelView] = React.useState(false);
  const [saveView, setSaveView] = React.useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [apiRefresh, setApiRefresh] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const getTabValue = useSelector(
    (state) => state.sharedState.ContactAnomaliesReducer.tabValue
  );
  const getContactAnomalies = useSelector(
    (state) => state.sharedState.ContactAnomaliesReducer.contactAnomaliesData
  );
  const getCopyContactAnomalies = useSelector(
    (state) =>
      state.sharedState.ContactAnomaliesReducer.copyContactAnomaliesData
  );
  const getContractInfoAnomalies = useSelector(
    (state) => state.sharedState.ContactAnomaliesReducer.contractAnomaliesData
  );
  const getMfgInfoAnomalies = useSelector(
    (state) => state.sharedState.ContactAnomaliesReducer.MFGAnomaliesData
  );
  const getNeedInfoAttCodeAnomalies = useSelector(
    (state) =>
      state.sharedState.ContactAnomaliesReducer.needAttCodeValueAnomaliesData
  );
  const saveContactData = useSelector(
    (state) =>
      state.sharedState.ContactAnomaliesReducer.saveContactAnomaliesData
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const getErrorMsg = useSelector(
    (state) => state.sharedState.ContactAnomaliesReducer.errorMessageInRedux
  );
  const successMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContactAnomaliesReducer?.successMessageInRedux;
  });
  const getInputValue = useSelector((state) => {
    return state.sharedState.ContactAnomaliesReducer.getInputValue;
  });
  const multipleSavePayloadAll = useSelector((state) => {
    return state.sharedState.ContactAnomaliesReducer.multipleSavePayloadAll;
  });
  // dispatch tab value into redux on tabChange
  const handleContactTabChange = () => {
    dispatch(dispatchTabValue('one'));
  };
  const handleContractsChange = () => {
    dispatch(dispatchTabValue('two'));
  };
  const handleManufacturersChange = () => {
    dispatch(dispatchTabValue('three'));
  };
  // full screen view on handle click
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  const handleChangeTabValue = () => {};
  // setTabValue from Redux
  React.useEffect(() => {
    setTabValue(getTabValue);
  }, [getTabValue]);
  // setInputValue from Redux
  React.useEffect(() => {
    let inputValue = isNumeric(getInputValue);
    if (inputValue && getInputValue) {
      setCurIndex(parseInt(getInputValue));
    } else {
      setCurIndex(getInputValue);
    }
  }, [getInputValue]);
  // set contact anomalies page data
  const assignContactAnomliesPageData = (indexNumber, onChangeValue) => {
    setContactAnoMaliesList(getContactAnomalies.contactAnomaliesResponseVOs);
    if (
      getErrorMsg?.length === undefined ||
      getErrorMsg?.length === 0 ||
      onChangeValue === 'true'
    ) {
      let inputParseIntValue = parseInt(indexNumber);
      let inputIndexValue = inputParseIntValue - 1;
      setContactValues(
        getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue]
      );
      if (
        getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue]
          .copySourceSeqNum != null
      ) {
        let copySearchCr = {
          contactSeqNum:
            getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue]
              .copySourceSeqNum,
        };
        dispatch(getCopyContactAnomaliesByCriteria(copySearchCr));
      } else {
        dispatch(dispatchCopyContactAnomaliesCriteriaList([]));
      }
      if (
        getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue]
          .contactSeqNum != null
      ) {
        let contractInfoCr = {
          invContactSeqNum:
            getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue]
              .contactSeqNum,
        };
        dispatch(getContractInfo(contractInfoCr));
      }
      if (
        getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue].key !=
        null
      ) {
        let mfgInfoCr = {
          mfgId:
            getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue]
              .key,
        };
        dispatch(getMfgInfo(mfgInfoCr));
      }
      if (
        getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue]
          .needsAttentionCd != null
      ) {
        let needInfoMsg = {
          codeValue:
            getContactAnomalies.contactAnomaliesResponseVOs[inputIndexValue]
              .needsAttentionCd,
        };
        dispatch(getNeedInfoMsg(needInfoMsg));
      }
    }
  };
  // get contact anomalies data from redux
  React.useEffect(() => {
    if (getContactAnomalies) {
      if (
        getContactAnomalies.message === 'Success' &&
        getContactAnomalies.contactAnomaliesResponseVOs.length != 0
      ) {
        if (apiRefresh) {
          let searchCr = {};
          dispatch(getContactAnomaliesByCriteria(searchCr));
          dispatch(dispatchInputValue(1));
          setApiRefresh(false);
        } else {
          assignContactAnomliesPageData(getInputValue, 'false');
        }
      } else if (
        getContactAnomalies.message === 'Success' &&
        getContactAnomalies.contactAnomaliesResponseVOs.length === 0
      ) {
        clearContactValues();
      } else {
        let searchCr = {};
        dispatch(getContactAnomaliesByCriteria(searchCr));
        dispatch(dispatchInputValue(1));
      }
    } else {
      let searchCr = {};
      dispatch(getContactAnomaliesByCriteria(searchCr));
      dispatch(dispatchInputValue(1));
    }
  }, [getContactAnomalies]);
  // clear contact values while no data present
  const clearContactValues = () => {
    setContactValues([]);
    setCopyContactValues([]);
    setContractValues([]);
    setMfgValues([]);
    setNeedCodeValues('');
    dispatch(dispatchInputValue(null));
    dispatch(dispatchCopyContactAnomaliesCriteriaList([]));
    setContactAnoMaliesList([]);
  };
  // get copy contact values from redux
  React.useEffect(() => {
    if (getCopyContactAnomalies && getContactAnomalies.message === 'Success') {
      setCopyContactValues(getCopyContactAnomalies.copyContactDetails);
    }
  }, [getCopyContactAnomalies]);
  // get contract info values from redux
  React.useEffect(() => {
    if (
      getContractInfoAnomalies &&
      getContractInfoAnomalies.message === 'Success'
    ) {
      setContractValues(getContractInfoAnomalies.contractResponseVOs);
    }
  }, [getContractInfoAnomalies]);
  // get manufacturere info values from redux
  React.useEffect(() => {
    if (getMfgInfoAnomalies && getMfgInfoAnomalies.message === 'Success') {
      setMfgValues(getMfgInfoAnomalies.mfgResponseVO);
    }
  }, [getMfgInfoAnomalies]);
  // get need attention info values from redux
  React.useEffect(() => {
    if (
      getNeedInfoAttCodeAnomalies &&
      getNeedInfoAttCodeAnomalies.message === 'Success'
    ) {
      setNeedCodeValues(getNeedInfoAttCodeAnomalies.needsAttentionMsg);
    }else{
      setNeedCodeValues("");
    }
  }, [getNeedInfoAttCodeAnomalies]);
  // cancel contact anomalies functinality
  const cancelContactAnomalies = () => {
    dispatch(dispatchMultipleSaveData([]));
    dispatch(dispatchErrorMessageData([]));
    dispatch(handleSuccessMessages([]));
    let searchCr = {};
    dispatch(getContactAnomaliesByCriteria(searchCr));
    dispatch(dispatchInputValue(getInputValue ? getInputValue : 1));
    setCancelView(false);
    setDisableSaveCancel(false);
  };
  // go to particular manufacturer action button handler function
  const goToManufacturer = async (selectedRow) => {
    dispatch(setSelectManufacturerData({}));
    dispatch(fetchAllManufacturerDetail(null));
    dispatch(getContactDetails(null));
    dispatch(maintainLabelerListData({}));
    dispatch(setMaintainManufacturerTab({}));
    const tempObj = {
      mfgId: selectedRow.data.mfgId,
      mfgName: selectedRow.data.mfgName,
      mfgTypeCd: selectedRow.data.mfgTypeCd,
    };
    tempObj.updateManufacturer = true;
    const result = await dispatch(setSelectManufacturerData(tempObj));
    if (result && Object.keys(result).length > 0) {
      redirectURLLink(
        '/manufacturer-detail',
        'Maintain Manufacturer',
        history,
        dispatch
      );
    }
  };
  // get save succuess message from redux
  React.useEffect(() => {
    if (saveContactData && saveContactData.message === 'Success') {
      cancelContactAnomalies();
      dispatch(dispatchInputValue(curIndex));
      dispatch(handleSuccessMessages([SUCCESSMESSAGE_GENERIC]));
      // setTimeout(() => {
        dispatch(dispatchSaveContact([]));
      //   dispatch(handleSuccessMessages([]));
      // }, 5000);
    } else if (saveContactData && saveContactData === 'close') {
      dispatch(dispatchSaveContact([]));
      dispatch(dispatchContactAnomaliesCriteriaList(undefined));
      dispatch(dispatchCopyContactAnomaliesCriteriaList(undefined));
      dispatch(dispatchContractCriteriaList(undefined));
      dispatch(dispatchMfgCriteriaList(undefined));
      dispatch(dispatchNeedInfoMsg(undefined));
      dispatch(dispatchSaveContact(undefined));
      closeTab(navigate, history);
    }
  }, [saveContactData]);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
  // Tab highlighter functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigate, true);
    } else {
      tabHighLigther(navigate, false);
    }
  }, [JSON.stringify(getErrorMsg)]);
  // on blur functinality of pagination text field
  const onBlurOnTextField = (diffValue) => {
    let indexValueAssign;
    let preValueInputValue;
    let inputValueNum = isNumeric(getInputValue);
    dispatch(handleSuccessMessages([]));
    if (diffValue === 'I') {
      if (inputValueNum) {
        indexValueAssign = parseInt(getInputValue) + 1;
        preValueInputValue = parseInt(getInputValue);
      } else {
        indexValueAssign = getInputValue + 1;
        preValueInputValue = getInputValue;
      }
    } else {
      if (inputValueNum) {
        indexValueAssign = parseInt(getInputValue) - 1;
        preValueInputValue = parseInt(getInputValue);
      } else {
        indexValueAssign = getInputValue - 1;
        preValueInputValue = getInputValue;
      }
    }
    setCurIndex(indexValueAssign);
    dispatch(dispatchInputValue(indexValueAssign));
    assignContactAnomliesPageData(indexValueAssign, 'false');
    setPageEdited(false);
    setApiRefresh(false);
    getContactAnomalies.contactAnomaliesResponseVOs[preValueInputValue - 1] =
      contactValues;
  };
  // to check if any page field edited or not
  React.useEffect(() => {
    if (pageEdited) {
      setSavePayload([...savePayload, contactValues]);
      setPageEdited(false);
      dispatch(dispatchMultipleSaveData(contactValues));
    }
  }, [pageEdited]);
  // on change functionality for paginate text field
  const paginateContactAnomaliesData = (curentIndex) => {
    setPageEdited(false);
    dispatch(handleSuccessMessages([]));
    dispatch(dispatchInputValue(curentIndex));
    let inputValue = isNumeric(curentIndex);
    let isInputValue = false;
    let arr = getErrorMsg ? (getErrorMsg.length > 0 ? getErrorMsg : []) : [];
    if (inputValue && curentIndex <= contactAnoMaliesList.length) {
      assignContactAnomliesPageData(curentIndex, 'true');
    }
    if (curentIndex && inputValue) {
      setCurIndex(parseInt(curentIndex));
    } else {
      setCurIndex(curentIndex);
    }
    if (inputValue && curentIndex > contactAnoMaliesList.length) {
      arr = arr.filter((item) => item.errorType != 'inputIsGreter');
      arr.push({
        field: 'input',
        errorType: 'inputIsGreter',
        message: INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
      });
    } else {
      isInputValue = true;
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, {
            field: 'input',
            errorType: 'inputIsGreter',
          })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    }
    if (inputValue && isInputValue && curentIndex !== '0') {
      arr = arr.filter((item) => item.errorType != 'validate');
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, {
            field: 'input',
            errorType: 'validate',
          })
        : null;

      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    } else {
      arr = arr.filter((item) => item.errorType != 'validate');
      if (inputValue && curentIndex < contactAnoMaliesList.length) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: ERR_PAGINATE_VALUE,
        });
      }
      if (inputValue === false) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: ERR_PAGINATE_VALUE,
        });
      }
    }
    const unique = [...new Set(arr)];
    dispatch(dispatchErrorMessageData(unique));
    setApiRefresh(false);
  };
  // majorSave functinality on click
  const majorSave = (saveCancel) => {
    const obj = multipleSavePayloadAll.reduce((acc, cur, index) => {
      acc[cur.contactSeqNum] = { index: cur };
      return acc;
    }, {});
    const filterSavePayload = Object.values(obj)
      .sort((a, b) => a.index - b.index)
      .map(({ index: val }) => val);
    let majorSaveData = {
      contactVOs: [filterSavePayload],
    };
    setSaveView(false);
    if (saveCancel) {
      dispatch(saveContactMajor(majorSaveData));
    } else {
      dispatch(saveContactMajorClose(majorSaveData));
    }
  };

  // for disable save cancel update
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (getContactAnomalies && Object.keys(getContactAnomalies).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/contactAnomalies' && disableSaveCancel) {
            item.isFormDirty = true;
          } else if (item.navTo === '/contactAnomalies')
            item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [disableSaveCancel || getContactAnomalies]);

  // handle close and confirm popup
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/contactAnomalies' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/contactAnomalies' && item.isFormSave) {
          item.isFormSave = false;
          majorSave();
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  return (
    <div
      className='tBillPanel custom-check'
      data-testid='contact-anomalies-component'
    >
      <div className='tabs-container'>
        <CustomSeparator parent1='Research' parent2='Contact Anomalies' />
        <DisplaySuccessMessages
          successMessages={
            successMessagesFromRedux ? successMessagesFromRedux : []
          }
        />
        {getErrorMsg?.length > 0 ? (
          <DisplayErrorMessages
            errorMessages={
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            }
          />
        ) : null}
        {!getContactAnomalies ||
        !getContactAnomalies.contactAnomaliesResponseVOs ||
        getContactAnomalies.contactAnomaliesResponseVOs.length === 0 ? (
          <DisplayErrorMessages errorMessages={[CONTACT_ANOMALIES_NO_DATA]} />
        ) : null}

        <SaveCancelPopup
          open={cancelView}
          title='Cancel'
          data-test='reset-button-uc'
          onConfim={cancelContactAnomalies}
          onCancel={(e) => setCancelView(false)}
          moduleName=''
        />
        <SaveCancelPopup
          open={saveView}
          title='Save'
          data-testid='save-api-uc'
          onConfim={majorSave}
          onCancel={(e) => setSaveView(false)}
          moduleName=''
        />
        <Box className='alone-pagination '>
          <Box>
            <Button
              title='Previous'
              className='btns rotate-left'
              data-testid='uc-paginate-arrow-left'
              disabled={
                !(getInputValue > 1) ||
                !isNumeric(getInputValue) ||
                getInputValue > contactAnoMaliesList.length
              }
              onClick={() => onBlurOnTextField('D')}
            >
              <SVGComponent iconName='Icon-arrow' />
              <span className='hide-elm' aria-hidden='true'>
                Previous
              </span>
            </Button>
          </Box>
          <Box>
            <label className='m-0' htmlFor='paginate-count'>
              <TextField
                id='paginate-count'
                data-testid='uc-input-paginate'
                variant='outlined'
                className='searchInput input-count'
                value={contactAnoMaliesList.length > 0 ? curIndex : ''}
                size='small'
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  paginateContactAnomaliesData(e.target.value);
                }}
              />
            </label>
          </Box>
          <Box className='btns'> of {contactAnoMaliesList.length}</Box>
          <Box>
            <Button
              title='Next'
              className='btns rotate-right ml-0'
              data-testid='uc-paginate-arrow-right'
              disabled={
                !(getInputValue < contactAnoMaliesList.length) ||
                !isNumeric(getInputValue)
              }
              onClick={() => onBlurOnTextField('I')}
            >
              <SVGComponent iconName='Icon-arrow' />
              <span className='hide-elm'>Next</span>
            </Button>
          </Box>
        </Box>
        {!fullScreenView && (
          <div className='row mb-2'>
            <div className='col-12'>
              <div className='row'>
                <div className='col-2 mt-3 pr-0'>
                  <label className='frr-legend-font'>{needsAttention}</label>
                </div>
                <div className='col-8 no-lbl pl-0'>
                  <div className='mui-custom-form input-md ml-0'>
                    <TextField
                      data-testid='needs-attention-textField'
                      id='needsAttentionId'
                      className='frr-display-hidden-label'
                      disabled
                      label={needsAttention}
                      fullWidth
                      placeholder=''
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={needsAttCodeValue}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='col-12 pl-0'>
              <div className='btn-wrapper float-right mt-4'>
                <Button
                  className='btn btn-success btn-save'
                  data-testid='open_Save'
                  onClick={() => setSaveView(true)}
                  disabled={!disableSaveCancel}
                >
                  <SVGComponent iconName='Icon-awesome-save' />
                  Save
                </Button>
                <Button
                  className='btn btn-cancel'
                  data-testid='open_Cancel'
                  disabled={!disableSaveCancel}
                  onClick={() => setCancelView(true)}
                >
                  <SVGComponent iconName='Icon-cancel' />
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        )}
        <div className='frr-tabs-wrapper'>
          <AppBar
            position='static'
            sx={{ width: '100%' }}
            style={{ borderBottom: '1px solid #c9c8c5' }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChangeTabValue}
              data-testid='index_tab'
              color='red'
              style={{ color: 'red' }}
            >
              <Tab
                style={{ textTransform: 'capitalize' }}
                value='one'
                label='Contact'
                data-testid='contact_tab'
                onClick={handleContactTabChange}
                tabIndex={0}
              />

              <Tab
                style={{ textTransform: 'capitalize' }}
                value='two'
                label='Contracts'
                data-testid='contracts_tab'
                onClick={handleContractsChange}
                tabIndex={0}
              />

              <Tab
                style={{ textTransform: 'capitalize' }}
                value='three'
                label='Manufacturers'
                data-testid='manufacturers_tab'
                onClick={handleManufacturersChange}
                tabIndex={0}
              />
            </Tabs>
          </AppBar>
        </div>
        <div className='tabs-body'>
          {tabValue === 'one' && (
            <Contact
              contactValues={contactValues}
              setContactValues={setContactValues}
              copyContactValues={copyContactValues}
              majorSave={majorSave}
              setSavePayload={setSavePayload}
              savePayload={savePayload}
              setPageEdited={setPageEdited}
              setDisableSaveCancel={setDisableSaveCancel}
              disableSaveCancel={disableSaveCancel}
              setCancelView={setCancelView}
              setSaveView={setSaveView}
              setApiRefresh={setApiRefresh}
            />
          )}
          {tabValue === 'two' && (
            <Contracts
              contractValues={
                contractValues &&
                contractValues.length > 0 &&
                contractValues.map((item) => {
                  item.endDt =
                    item.endDt !== null
                      ? moment(item.endDt).format('MM/DD/yyyy')
                      : null;
                  item.startDt =
                    item.startDt !== null
                      ? moment(item.startDt).format('MM/DD/yyyy')
                      : null;
                  return item;
                })
              }
              handleFullScreenView={handleFullScreenView}
              setFullScreenView={setFullScreenView}
              fullScreenView={fullScreenView}
              history={history}
            />
          )}
          {tabValue === 'three' && (
            <Manufacturers
              handleFullScreenView={handleFullScreenView}
              setFullScreenView={setFullScreenView}
              fullScreenView={fullScreenView}
              goToManufacturer={goToManufacturer}
              mfgValues={mfgValues}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default ContactAnomalies;
